module.exports = __webpack_public_path__ + "img/d6e2c8d.png";